import React from 'react';

const ValidationContext = React.createContext();

export default ValidationContext;
